// i18n area 'cluster' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.cs-CZ.meta.json.
import type { enUS } from './cluster'

export const csCZ: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Záruční přístupy',
      subtitle: 'Servisní dveře uzlu: přístup jen pro čtení s dočasným heslem a nouzový účet s heslem z trezoru',
      readOnlyTitle: 'Přístup jen pro čtení (trantor)',
      stateNone: 'zavřený',
      stateGranted: 'otevřený',
      stateGrantedPending: 'udělen — aplikuje se na uzlu',
      grantedBy: 'Udělil',
      grantedAt: 'Uděleno',
      expiresAt: 'Vyprší',
      reason: 'Důvod',
      endedAt: 'Zavřený',
      endedReason: {
        revoked: 'odvolán',
        expired: 'vypršel (TTL)',
        reboot: 'restart uzlu',
        failed: 'neaplikován (úloha selhala)'
      },
      grant: 'Udělit přístup jen pro čtení…',
      grantTitle: 'Udělit přístup jen pro čtení',
      grantSubmit: 'Udělit',
      grantError: 'Udělení bylo odmítnuto',
      grantConfirm: 'TVirt vygeneruje dočasné heslo pro systémového uživatele «trantor» (jen čtení: journal a diagnostika, bez sudo) a nastaví ho na uzlu úlohou. Heslo se zobrazí POUZE jednou, při potvrzení; končí vypršením, odvoláním nebo při příštím restartu uzlu.',
      reasonLabel: 'Důvod',
      reasonHint: 'Proč otevíráte dveře: zůstane v udělení, v auditu a v deníku',
      ttlLabel: 'Doba trvání',
      ttlHours: '{n} h',
      revoke: 'Odvolat přístup jen pro čtení…',
      revokeTitle: 'Odvolat přístup jen pro čtení',
      revokeSubmit: 'Odvolat',
      revokeError: 'Odvolání bylo odmítnuto',
      revokeConfirm: 'Udělení končí okamžitě a úloha znovu zamkne uživatele «trantor» na uzlu: dočasné heslo přestane platit.',
      passwordTitle: 'Heslo jen pro čtení',
      passwordOnce: 'Toto heslo se zobrazí POUZE jednou: zkopírujte ho nyní. Nikde se neukládá a nebude možné ho znovu přečíst — pokud ho ztratíte, udělte znovu.',
      passwordUser: 'Uživatel',
      passwordLabel: 'Heslo',
      passwordHint: 'Platí do {until} nebo do příštího restartu uzlu; použitelné, jakmile je úloha udělení dokončena. Přístup: ssh trantor@<adresa uzlu>.',
      emergencyTitle: 'Poslední nouzový přístup (trantor-emergency)',
      lastLogin: '{time} přes {via} z {from}',
      lastLoginNone: 'žádný nepozorován',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konzole',
        sudo: 'sudo',
        unknown: 'neznámý'
      },
      emergencyHint: 'Nouzový účet «trantor-emergency» (plné sudo) je vždy povolen s heslem vygenerovaným při instalaci uzlu a uloženým v trezoru: TVirt ho nezná, nerotuje ani neobnovuje. Každé přihlášení se hlásí zde a v deníku událostí.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall uzlů',
      subtitle: 'Postoj rulesetu nftables, který každý uzel aplikuje sám na sebe — jediný firewall uzlu (firewalld je vypnutý)',
      modeLabel: 'Postoj',
      mode: {
        disabled: 'Vypnutý — žádný ruleset na uzlech',
        permissive: 'Permisivní — počítá a loguje, nic nezahazuje',
        enforced: 'Vynucený — dovnitř se dostane jen odvozený registr'
      },
      hint: {
        disabled: 'Jako dnes: uzly nenesou žádný ruleset. Přepněte na permisivní, abyste si PŘEČETLI, co by se zahodilo, dřív než se to zahodí.',
        permissive: 'Každý uzel aplikuje svůj odvozený ruleset s policy accept: co by vynucený režim zahodil, se počítá a loguje (prefix v journalu «tvirt-node would-drop:»). Nic se neblokuje.',
        enforced: 'Každý uzel aplikuje svůj odvozený ruleset s policy drop: ssh a API odkudkoli, store / live migration / overlay / Ceph jen od členů, listenery síťových služeb z obsluhované sítě. Každá změna je apply s potvrzením — uzel, který nedokáže potvrdit, se sám vrátí zpět.'
      },
      confirmTitle: 'Vynutit firewall uzlů?',
      confirmBody: 'Každý uzel aplikuje ruleset s potvrzením: do lhůty sonduje backend, store a ssh skrz nová pravidla a potvrdí — jinak se sám vrátí k předchozímu rulesetu. Nejdřív si přečtěte čítače permisivního režimu na uzlech.',
      confirmSubmit: 'Vynutit',
      confirmCancel: 'Zrušit',
      lensTitle: 'Firewall uzlu',
      loadError: 'Lupu firewallu uzlu se nepodařilo načíst',
      noReport: 'Od tohoto uzlu zatím žádná zpráva o firewallu — worker ji podá při příštím průchodu',
      firewalldActive: 'Na tomto uzlu běží firewalld: firewall uzlu se odmítá aplikovat vedle něj (zamaskujte firewalld)',
      conditionUnconfirmed: 'Zatím žádný potvrzený ruleset — uzel je otevřený',
      conditionRolledBack: 'Poslední apply se vrátil zpět — stejná generace se nezkouší znovu, dokud se nezmění registr nebo se znovu nezmění postoj',
      lastError: 'Poslední chyba',
      posture: 'Postoj',
      observedAt: 'Pozorováno',
      desiredGeneration: 'Požadovaná generace',
      componentTitle: 'Komponenta uzlu',
      componentSubtitle: 'tvirt-node-firewall — při bootu aplikuje potvrzený ruleset, nepotvrzený sama vrátí zpět',
      componentAbsent: 'Komponenta zatím nic nenahlásila',
      phase: 'Fáze',
      phases: {
        none: 'Nikdy neaplikováno',
        applied: 'Aplikováno — čeká na potvrzení',
        confirmed: 'Potvrzeno',
        rolledBack: 'Vráceno zpět'
      },
      generation: 'Generace',
      appliedAt: 'Aplikováno dne',
      confirmedAt: 'Potvrzeno dne',
      deadline: 'Lhůta rollbacku',
      lastRollback: 'Poslední rollback',
      registryTitle: 'Odvozený registr',
      registrySubtitle: 'Porty, které tento uzel otevírá, podle třídy a původu — odvozené z klastru, nikdy neupravované ručně',
      registryEmpty: 'Nic odvozeného — postoj vypnutý bez potvrzeného rulesetu, nebo zatím žádná zpráva',
      colClass: 'Třída',
      colPort: 'Port',
      colSource: 'Zdroj',
      colOrigin: 'Původ',
      classes: {
        public: 'Veřejná',
        internode: 'Meziuzlová',
        tenant: 'Tenant'
      },
      sourceMembers: 'jen členové',
      sourceAnywhere: 'odkudkoli',
      sourceBridge: 'na {iface}'
    },
    derivationDerived: 'odvozený',
    derivationDiverged: 'odchýlený',
    derivationDerivedTip: 'Síťový dokument je ODVOZEN z fabric {fabric} a stále se shoduje s renderem na aktuálních vstupech — klikněte pro plán derivace.',
    derivationDivergedTip: 'Derivace z fabric {fabric} se po posledním apply změnila (fabric, kabeláž, role nebo reference) — klikněte pro čekající diff.',
    derivationRetiring: {
      one: '{n} adresa se vyprazdňuje',
      few: '{n} adresy se vyprazdňují',
      many: '{n} adresy se vyprazdňuje',
      other: '{n} adres se vyprazdňuje'
    },
    standaloneHint: 'Tento uzel nemá klastr: ještě nebyl nainstalován. Klastry se při instalaci vytvářejí NEBO joinují — join token vyražený z tabulky Servery některého člena se předá instalátoru (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Vaše oprávnění pokrývají jeden scope, ne celý klastr: inventář flotily — uzly, nastavení a zařízení — vidí jen správci klastru.',
    phaseReady: 'Připraven',
    phaseForming: 'Formuje se',
    storeMembers: 'Členové store',
    watermark: 'Práh konvergence',
    configGeneration: 'Generace config',
    converged: 'sladěno',
    behind: 'pozadu — {m} / {n}',
    revision: 'Revize',
    rolesTitle: 'Síťové role',
    rolesSubtitle: 'Adresy jednotlivých členů pro každou třídu provozu — samotná konektivita žije v síti hostitele',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'dědí management',
    settingsTitle: 'Nastavení',
    settingsSubtitle: 'Bezpečnostní politika pro celý klastr — každý uzel ji vyhodnocuje ze své lokální repliky',
    taskRetentionTitle: 'Retence úloh',
    taskRetentionSubtitle: 'Jednotný GC pro všechny úlohy — dokončené úlohy nad limit stáří nebo počtu se sbírají, běžící nikdy',
    taskRetentionMaxAge: 'Maximální stáří (dny)',
    taskRetentionMaxCount: 'Maximální počet úloh',
    eventRetentionTitle: 'Retence událostí',
    eventRetentionSubtitle: 'GC žurnálu — politika nezávislá na úlohách: úloha je fronta, událost je paměť',
    eventRetentionMaxAge: 'Maximální stáří (dny)',
    eventRetentionMaxCount: 'Maximální počet událostí',
    spaceThresholdsTitle: 'Prahy místa',
    spaceThresholdsSubtitle: 'Kdy se plnící se úložiště dostane do žurnálu (a notifikací)',
    spaceLowPct: 'Varování od (% využito)',
    spaceCriticalPct: 'Kritické od (% využito)',
    spaceOrderError: 'Kritické nemůže být pod varováním',
    spaceThresholdsHint: 'Konfigurují se jen vstupy: výstup odvozuje engine, 5 bodů pod každým prahem, aby se úložiště stojící na hranici nikdy nestalo metronomem',
    failoverReserveTitle: 'Rezerva pro failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM držená volná, aby klastr mohl po ztrátě uzlů restartovat svou zátěž',
    failoverReserveTolerate: 'Tolerovaný počet výpadků uzlů',
    failoverReserveOff: '0 — rezerva je vypnutá: žádné spuštění není nikdy odmítnuto kvůli kapacitě pro failover',
    failoverReserveOn: 'Spuštění VM, které by ukrojilo z rezervy, je odmítnuto chybou 412, která vysvětluje čísla',
    networkShapingTitle: 'Spravedlivé sdílení pásma',
    networkShapingSubtitle: 'Tři typologické váhy shaping stromu na uplink — působí jen při soupeření o pásmo',
    networkShapingRest: 'Váha zbytku (řídicí rovina, storage, repliky)',
    networkShapingOverlay: 'Váha overlay sítí',
    networkShapingLiveMigration: 'Váha live migration',
    networkShapingHint: 'Zaručený podíl = váha / součet tří (výchozí 300 / 100 / 200, každá od 1 do 10000); na nevytíženém spoji si každá třída může vzít celé pásmo',
    debugModeTitle: 'Režim debug',
    debugModeSubtitle:
      'Podrobné chyby v obecných hláškách GUI — abyste viděli skutečnou příčinu, když akce označená jako «neúspěšná» ve skutečnosti uspěla',
    debugModeLabel: 'Režim debug zapnuto',
    debugModeOn: 'Obecné chybové hlášky připojují kořenovou příčinu — vnitřní detaily viditelné pro každého operátora',
    debugModeOffHint: 'Vypnuto — obecné chybové hlášky zůstávají obecné, bez vnitřních detailů',
    nodeDetailsAction: 'Podrobnosti uzlu',
    node: {
      docTitle: 'Uzel',
      notFound: 'Uzel nenalezen',
      tabOverview: 'Přehled',
      tabStats: 'Statistiky',
      tabNetwork: 'Síť',
      tabSettings: 'Místní nastavení',
      identityTitle: 'Identita',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Port YSQL',
      revision: 'Revize config',
      versionsTitle: 'Pozorované verze',
      heartbeatSubtitle: 'Poslední stav, který uzel nahlásil sám o sobě',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Model CPU',
      memoryTitle: 'Paměť',
      hugePagesTitle: 'Obrovské stránky',
      hugePagesPool: '{size}: {free} volných z {total}',
      hugePagesNone: 'Žádný pool',
      hugePagesNoneHint: 'Uzel nemá rezervované žádné obrovské stránky: VM, které je požadují, se zde nemohou spustit. Pool se deklaruje na uzlu, parametry kernelu hugepagesz a hugepages, nebo zápisem nr_hugepages.',
      usageTitle: 'Aktuální využití',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nepozorováno — žádný čerstvý vzorek',
      statsNoData: 'Ve zvoleném intervalu nejsou žádná data — série uzlu vzorkuje uzel sám a poskytuje je lokálně.',
      observedTitle: 'Pozorovaný stav',
      observedSubtitle: 'Služby a assety lokální na uzlu, jak je vidí worker'
    },
    editRolesTitle: 'Upravit síťové role',
    memberNode: 'Uzel',
    memberIp: 'IP adresa',
    addMember: 'Přidat člena',
    lmInherit: 'Použít adresy managementu',
    roleIpHint: 'Přidávání a odebírání členů je volné; změna IP existujícího člena na místě se odmítá — postup migrace IP dorazí v některém z dalších roundů.',
    roleError: 'Role se nepodařilo aktualizovat',
    nodesTitle: 'Uzly',
    addNodeTitle: 'Přidat uzel do klastru',
    addNode: 'Přidat uzel',
    addNodeError: 'Uzel se nepodařilo předregistrovat',
    nodeName: 'Název uzlu',
    nodeNameHint: 'musí se shodovat se jménem zvoleným při instalaci',
    nodeIp: 'IP pro management',
    colName: 'Název',
    colPhase: 'Fáze',
    colServices: 'Služby',
    colWatermark: 'Watermark',
    colLastSeen: 'Poslední kontakt',
    colUps: 'UPS',
    upsCordonChip: 'kordon UPS',
    upsCordonTip: 'Uzel se odsoudil na základě faktů své UPS ({time}): kordon sám uvolní, jakmile bude síť stabilní a baterie nabitá',
    upsUnreachable: 'UPS nedostupná',
    upsOnBattery: 'Na baterii',
    upsOnLine: 'Na síti',
    upsLowBattery: 'slabá baterie',
    upsNoEstimateChip: 'výdrž neodhadnuta',
    upsNoEstimateTip: 'UPS nepublikuje odhad výdrže: uzel je odsouzen pouze příznakem LB (slabá baterie) UPS — nastavte battery.runtime.low / LB na samotné UPS',
    upsLaneTip: 'Cesta vypnutí UPS od {since}: odsouzen kvůli {by}',
    upsUnit: 'jednotka',
    upsStatus: 'stav NUT',
    upsLoad: 'zátěž',
    upsOnBatterySince: 'na baterii od',
    upsOnLineSince: 'na síti od',
    upsError: 'chyba',
    upsObservedAt: 'pozorováno',
    upsNone: 'žádná jednotka UPS tento uzel neobsluhuje',
    upsBy: {
      runtime: 'výdrž pod prahem',
      lowBattery: 'příznak LB UPS',
    },
    upsLane: {
      evacuate: 'evakuace',
      local: 'vypnutí na místě',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'zastavování hostů',
      stoppingServices: 'zastavování služeb',
      poweredOff: 'vypnuto',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Jednotky UPS a prahy: uzel odsouzen při výdrži ≤ práh nebo příznaku LB (vždy respektován), obnovení s hysterezí',
    upsRuntimeThreshold: 'Práh výdrže (s)',
    upsRuntimeThresholdHint: 'Na baterii s odhadovanou výdrží ≤ práh se uzel vypne v pořadí (výchozí 300)',
    upsResumeStable: 'Síť stabilní po (s)',
    upsResumeStableHint: 'Obnovení jen s nepřetržitou sítí alespoň tolik sekund (výchozí 60)',
    upsResumeCharge: 'Minimální nabití při obnovení (%)',
    upsResumeChargeHint: 'A baterie nabitá alespoň na toto procento (výchozí 25)',
    upsPolicyNote: 'Příznak LB (slabá baterie) UPS odsuzuje vždy a nelze jej vypnout; práh na čas strávený na baterii neexistuje. Každá jednotka může tři čísla přepsat.',
    upsUnitNew: 'nová jednotka',
    upsUnitSelectors: '{n} selektor(y) podle tagů (pouze CLI)',
    upsUnitName: 'Název jednotky',
    upsUnitMode: 'Režim',
    upsModeExternal: 'externí (cizí upsd)',
    upsModeManaged: 'spravovaná (UPS připojená k uzlu)',
    upsUnitUpsname: 'Název NUT (upsname)',
    upsUnitHost: 'Hostitel upsd',
    upsUnitAttachedNode: 'Připojený uzel',
    upsUnitDriver: 'Ovladač NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Zařízení ovladače',
    upsUnitDeviceHint: 'řádek port= v ups.conf: prázdné = auto',
    upsUnitPort: 'Port upsd',
    upsUnitServedNodes: 'Obsluhované uzly',
    upsUnitServedNodesHint: 'názvy uzlů oddělené čárkami (selektory podle tagů přes CLI)',
    upsUnitOverrideHint: 'prázdné = výchozí clusteru',
    upsUnitAdd: 'Přidat jednotku',
    unreachableSince: 'Nedostupný — poslední heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane ještě nezrealizoval aktuální overlay konfiguraci',
    overlaysError: 'Poslední průchod rekonciliace overlay selhal: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Čeká na join',
      'joining': 'Připojuje se',
      'member': 'Člen'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Zobrazen jen teď — ihned jej zkopírujte, už nikdy nepůjde přečíst',
    copy: 'Kopírovat',
    copied: 'Zkopírováno',
    close: 'Zavřít',
    revokeTitle: 'Odvolat předregistraci',
    revoke: 'Odvolat',
    revokeError: 'Registraci se nepodařilo odvolat',
    promote: 'Povýšit na store member',
    demote: 'Odebrat roli store-member',
    troubleshoot: 'Řešení potíží',
    promoteTitle: 'Povýšit na store member',
    demoteTitle: 'Odebrat roli store-member',
    promoteHint: 'Uzel vstoupí do kvora masterů YugabyteDB. Skutečná HA vyžaduje tři store membery.',
    demoteHint: 'Uzel opustí kvorum masterů a zastaví své služby store.',
    storeError: 'Změna store-member byla odmítnuta',
    attest: 'Prohlásit za vypnutý…',
    attestTitle: 'Prohlásit uzel za vypnutý',
    attestSubmit: 'Prohlásit za vypnutý',
    attestConfirm: 'Prohlašujete tento uzel za vypnutý, na vlastní riziko: prohlášení uzlu, který ve skutečnosti žije, riskuje dvojí běh VM. Jeho úlohy se označí jako selhané a authority jeho VM se stanou přenositelnými.',
    attestError: 'Prohlášení bylo odmítnuto',
    attestedChip: 'prohlášen za vypnutý',
    maintenanceChip: 'údržba',
    guestToolsChip: 'TVirt Guest Tools (ISO asset lokální na uzlu)',
    maintenanceEnter: 'Zahájit údržbu',
    maintenanceExit: 'Ukončit údržbu',
    maintenanceEnterTitle: 'Zahájit údržbu',
    maintenanceExitTitle: 'Ukončit údržbu',
    maintenanceEnterSubmit: 'Zahájit údržbu',
    maintenanceExitSubmit: 'Ukončit údržbu',
    maintenanceEnterConfirm: 'Uzel je odstaven a vyprázdněn: síťové služby a instance App, jejichž authority drží, jsou přeneseny (instance za studena: zastaveny a sklizeny zde, znovu vytvořeny na cílovém uzlu — výpadek), běžící VM jsou migrovány za živa, kde to jde, jinak elegantně zastaveny, rozpracované úlohy se dokončí, nová práce čeká a zastavené VM ztrácejí svou authority — Proximity je znovu umístí při dalším spuštění. Po skončení údržby se nic nevrací samo.',
    maintenanceExitConfirm: 'Uzel znovu začne přijímat práci a Proximity ho opět zvažuje pro umístění. VM se vrátí, jen když jsou spuštěny.',
    maintenanceError: 'Požadavek na údržbu byl odmítnut',
    maintenancePlanTitle: 'Plán evakuace',
    maintenancePlanLoading: 'Výpočet plánu evakuace…',
    maintenancePlanError: 'Plán evakuace se nepodařilo načíst — drain přesto zmigruje, co půjde, a zbytek zastaví.',
    maintenancePlanEmpty: 'Na tomto uzlu není co evakuovat — žádná aktivní síťová služba, žádná instance App požadovaná v běhu, žádná běžící VM.',
    maintenancePlanSummary: '{migrate} objektů bude migrovat (VM, síťové služby, instance App), {stop} se zastaví nebo zůstanou, kde jsou.',
    maintenancePlanReserve_ok: 'Rezerva pro failover po vyklizení: nedotčena — zbývá {headroom} GiB spustitelných při toleranci ztráty {n} uzlu/ů.',
    maintenancePlanReserve_eroded: 'Rezerva pro failover po vyklizení: téměř spotřebována — zbývá jen {headroom} GiB z {reserve} GiB držených volných pro výpadek {n} uzlu/ů.',
    maintenancePlanReserve_exhausted: 'Rezerva pro failover po vyklizení: VYČERPÁNA — chybí {headroom} GiB z {reserve} GiB potřebných k toleranci výpadku {n} uzlu/ů. Dokud je tento uzel mimo, nová spuštění VM budou odmítána.',
    maintenancePlanReserve_unknown: 'Rezerva pro failover po vyklizení: nelze spočítat — žádný zbývající uzel nenahlásil svou paměť.',
    maintenancePlanReserveHugePages: 'Obrovské stránky {size} po vyklizení — volné: {free} z {capacity}, požadované jako rezerva: {reserve}.',
    maintenancePlanActionMigrate: 'migruje',
    maintenancePlanActionMigrateWarning: 'migruje (porušeno soft pravidlo)',
    maintenancePlanActionStop: 'zastaví se',
    maintenancePlanActionBlocked: 'zablokována',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'síťová služba',
    maintenancePlanKindApp: 'instance App',
    maintenancePlanColdMove: 'Přesun za studena: pod je zde zastaven a sklizen a znovu vytvořen na cílovém uzlu jeho workerem — výpadek do dalšího passu cílového workeru.',
    caFingerprint: 'Fingerprint CA klastru',
    staleChip: 'neaktuální',
    troubleshootTitle: 'Řešení potíží se store',
    restartStore: 'Restartovat služby store',
    restartHint: 'Pokud store zlobí, restartujte jeho služby. Pokročilé — používejte opatrně.',
    restartQueued: 'Úloha restartu zařazena do fronty',
    restartError: 'Služby se nepodařilo restartovat',
    svcActive: 'aktivní',
    svcWanted: 'chtěná, neběží',
    svcStopped: 'zastavená',
    noServices: 'Žádné služby nenahlášeny'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Inventář GPU celého klastru seskupený podle modelu — pozorované karty po uzlech, s označenými registracemi a jejich tagy',
    usbTitle: 'Prostředky USB',
    usbSubtitle: 'Inventář USB celého klastru seskupený podle modelu — pozorovaná zařízení po uzlech, s registracemi obou modelů (podle zařízení, podle portu) a jejich tagy',
    markedChip: 'použitelných pro TVirt: {n}',
    orphanChipGpu: 'osiřelých: {n}',
    orphanChipUsb: 'osiřelých: {n}',
    colNode: 'Uzel',
    colRegistration: 'Registrace',
      noRegsHint: 'Žádná registrace — zařízení označíte jako "použitelné pro TVirt" z dialogu uzlu (Uzly › uzel › Nastavení).',
      colDevice: 'Zařízení',
      colObserved: 'Pozorováno',
      colRegs: 'Registrace',
      regsNone: 'žádná',
      colPci: 'Adresa PCIe',
      colIdentity: 'Identita / port',
      colClasses: 'Třídy (tagy)',
      colActions: 'Akce',
      manageOnNode: 'Spravovat na uzlu {node} (označování žije v dialogu uzlu)',
      introTitle: 'Inventář zařízení USB a PCIe použitelných pro TVirt© v celém klastru.',
      introStep1: '1. Uzly objevují své GPU a USB zařízení samy (sčítání v heartbeatu).',
      introStep2: '2. Zařízení označíte jako "použitelné pro TVirt" z dialogu UZLU (Uzly › uzel › Nastavení) — označení ho naváže na vfio a zaregistruje ho zde.',
      introStep3: '3. Zde dáváte registracím jejich TŘÍDY přes tagy (např. gpu_class=compute): požadavky VM si řeknou o třídu a scheduler vybere uzel s volným odpovídajícím zařízením.',
    colMode: 'Režim',
    colState: 'Stav',
    colNotes: 'Poznámky',
    colTags: 'Tagy',
    modeDevice: 'podle zařízení',
    modePort: 'podle portu',
    usable: 'použitelné',
    orphanGpu: 'osiřelá',
    orphanUsb: 'osiřelé',
    hubChip: 'hub',
    orphanPortsTitle: 'Registrace podle portu bez připojeného zařízení — znovu připojte zařízení, nebo je odznačte z uzlu',
    gpusEmpty: 'Na žádném uzlu zatím nebyla pozorována žádná GPU',
    usbEmpty: 'Na žádném uzlu zatím nebylo pozorováno žádné USB zařízení'
  },

  // Sdílený slovník formulářů nastavení (refactoring 2026-07-24): pole security
  // sytí kartu nastavení stránky Klastr, pole uzlu stránku node-settings —
  // stránka /system/settings, pro kterou vznikla, je mrtvá.
  settings: {
    passwordMinLength: 'Minimální délka hesla',
    sessionIdle: 'Timeout nečinnosti relace (minuty)',
    lockoutThreshold: 'Uzamčení po neúspěšných pokusech',
    lockoutDuration: 'Doba uzamčení (minuty)',
    keyboardLayout: 'Rozložení klávesnice',
    keyboardLayoutHint: 'např. it, en-us — prázdné pro default QEMU',
    syslogEndpoint: 'Endpoint syslogu',
    syslogEndpointHint: 'host:port — prázdné vypne přeposílání',
    syslogTls: 'TLS',
    maxQueued: 'Maximum úloh ve frontě',
    concurrency: 'Souběžnost workeru',
    concurrencyHint: 'Worker ji aplikuje za běhu',
    notesTitle: 'Poznámky',
    save: 'Uložit',
    saved: 'Nastavení uloženo',
    saveError: 'Nastavení se nepodařilo uložit'
  },
  localSettings: {
    derivedChip: 'odvozený',
    derivedTip: 'Toto device VLASTNÍ derivace fabric (H2): editor se ho odmítá dotknout — upravte fabric (nebo kabeláž) a znovu aplikujte, nebo si ho vezměte zpět níže.',
    takeOwnership: 'Převzít vlastnictví',
    takeOwnershipTitle: 'Převzít vlastnictví (take-ownership)',
    takeOwnershipConfirm: '{name} opouští blok fabric a stává se znovu RUČNÍM devicem, které řídí tento editor. Uzel se stane odchýleným a příští apply derivace na něm odmítne (manualConflict), dokud ho nepřejmenujete nebo neodstraníte — nebo neopravíte fabric.',
    nodeSettingsTitle: 'Nastavení uzlu',
    nodeSettingsSubtitle: 'Co tento uzel vynucuje — fronta úloh, konzole, přeposílání logů — plus jeho tagy a poznámky',
    baseTitle: 'Rezervace hostitele (TVirt Proximity)',
    baseSubtitle: 'CPU a RAM vyhrazené pro OS hostitele — vstupy empirické kapacity, podle níž Proximity umísťuje VM',
    baseMemory: 'Základní RAM (MiB)',
    baseMemoryHint: 'Pozorovaný celek: {total} MiB. Použitelné pro VM = celkem − základ − RAM spuštěných VM umístěných zde.',
    baseMemoryHintNoTotal: 'Použitelné pro VM = pozorovaný celek − základ − RAM spuštěných VM umístěných zde.',
    baseCpu: 'Základní jádra CPU',
    baseCpuHint: 'Pozorované logické CPU: {total}. Slouží jen jako váha pro ranking — overcommit vCPU je normální.',
    baseCpuHintNoTotal: 'Slouží jen jako váha pro ranking — overcommit vCPU je normální.',
    baseHint: 'RAM je tvrdá brána admission control: VM, která se do použitelné RAM nevejde, je odmítnuta výmluvnou chybou. Na hostitelích, kde běží store membery nebo daemony Ceph, základ zvyšte.',
    placementTitle: 'Fyzické umístění',
    placementSubtitle: 'Kde tento server fyzicky stojí — deklarováno jednou, ať slouží čemukoli',
    placementHint: 'Umístění řídí hierarchii CRUSH každého klastru Ceph s OSD na tomto serveru: uložení změny srovná jejich mapy úlohou (host → rack → … → root). Částečné deklarace jsou legální — prázdné úrovně se prostě sbalí. Jména se sdílejí přes celou mapu: dva servery ve stejném racku deklarují stejné jméno racku.',
    placementNameInvalid: 'DNS-safe jméno (malá písmena, číslice, pomlčky)',
    placementEmpty: 'Prázdné = nedeklarováno',
    placementLevel: {
      chassis: 'Šasi',
      rack: 'Rack',
      row: 'Řada',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Místnost',
      datacenter: 'Datacentrum',
      zone: 'Zóna',
      region: 'Region'
    },
    cablingTitle: 'Kabeláž',
    cablingSubtitle: 'Do kterého portu přepínače je zapojeno každé rozhraní — deklarace žije na uzlu (Annex O.9)',
    cablingHint: 'Jeden kabel na NIC, jeden kabel na port v celé flotile (API odmítne s uvedením držitele). Kabeláž do portu, který je členem LAGG, je legální — to je případ bondu: budoucí odvození jej vykreslí jako LACP.',
    cablingInterface: 'Rozhraní',
    cablingNotCabled: '— nezapojeno —',
    cablingNoInterfaces: 'Zatím nebyla pozorována žádná síťová rozhraní',
    disksTitle: 'Disky',
    disksSubtitle: 'Pozorovaná bloková zařízení — jeden průzkum na průchod rekonciliace; zde označte disky použitelné jako OSD Ceph (N.15: způsobilost je explicitní)',
    colDataDisk: 'Datový disk',
    dataDisksHint: 'Zaškrtnutí zařízení jej deklaruje jako použitelné jako OSD; sériové číslo je jeho identitní pin — zkopírované z hardwaru, když ho zařízení hlásí, jinak vyražené (tvirt-…). Dialog registrace Ceph nabízí jen deklarované disky.',
    diskDeclaredSerial: 'deklarováno',
    diskNotObserved: 'deklarován, ale nepozorován — znovu připněte zařízení, nebo zrušte označení',
    noDisks: 'Zatím nebylo pozorováno žádné blokové zařízení',
    colSerial: 'Sériové číslo',
    colModel: 'Model',
    colSize: 'Velikost (GiB)',
    colDiskType: 'Typ',
    colInUse: 'Používá se',
    colObservedAt: 'Pozorováno',
    diskInUse: 'používá se',
    diskFree: 'volný',
    diskMounted: 'připojen',
    diskPartitions: 'oddíly',
    passthroughTitle: 'Zařízení passthrough',
    passthroughSubtitle: 'Pozorované GPU a USB zařízení — zde označte, co smí TVirt předávat VM; označení registruje identitu zařízení (round U1+G1)',
    passthroughHint: 'Označení zařízení registruje (stabilní id — cíl tagů a požadavků na třídu). Označená GPU má CELOU svou skupinu IOMMU navázanou na vfio-pci naráz — hostitele opouští okamžitě; odznačení znovu naváže nativní ovladač. Pro USB existují oba ratifikované modely: podle zařízení (vendor+product, ať je zapojeno kdekoli) a podle fyzického portu (VM dostane, cokoli je tam zrovna zastrčeno). USB se při označení nikdy neváže — attach probíhá za běhu VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Použitelné pro TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adresa PCI',
    colDriver: 'Ovladač',
    colVerdict: 'Verdikt',
    gpuEligible: 'Způsobilá',
    gpuIneligible: 'Nezpůsobilá',
    gpuReason: {
      'no-iommu': 'IOMMU není na hostiteli aktivní',
      'group-spans-slots': 'skupina IOMMU není izolovaná: zasahuje do dalších slotů',
      'multiple-display': 'skupina IOMMU není izolovaná: víc než jedna zobrazovací funkce',
      'foreign-function': 'skupina IOMMU není izolovaná: obsahuje cizí funkci'
    },
    vfioNotReady: 'IOMMU není na tomto hostiteli aktivní: žádná GPU není způsobilá, dokud ho platforma hostitele nezapne (OEM ISO) — TVirt nikdy neupravuje kernel args za běhu.',
    vfioMissingKernelArg: 'IOMMU není na tomto hostiteli aktivní: firmware hlásí VT-d/AMD-Vi (tabulka ACPI DMAR/IVRS přítomna), ale chybí kernel arg — přidejte intel_iommu=on (Intel) nebo odeberte amd_iommu=off (AMD) z command line kernelu a restartujte. TVirt nikdy neupravuje kernel args za běhu.',
    vfioFirmwareDisabled: 'IOMMU není na tomto hostiteli aktivní: VT-d/AMD-Vi je ve firmwaru vypnuté (žádná tabulka ACPI DMAR/IVRS), nebo ho CPU nepodporuje — zapněte ho v setupu firmwaru, žádný kernel arg ho nezapne. TVirt nikdy neupravuje hostitele za běhu.',
    gpuBindError: 'Bind vfio-pci selhal na {address}: {error}',
    firewallBridgesTitle: 'Firewall na nespravovaných bridge',
    firewallBridgesSubtitle: 'Ručně postavené bridge na tomto uzlu, jejichž setup souhlasí s firewallovými chainy, které TVirt vykresluje na připojených hostovských NIC',
    firewallBridgesHint: 'TVirt na cizí bridge nikdy nesahá — chain se kotví na tap/veth, který je vždy TVirtu vlastní. Seznam je brána souhlasu: default-deny a anti-spoofing umí rozbít to, co ruční setup očekává, takže NIC s firewallem na nespravovaném bridge, který tu NENÍ uveden, je odmítnuta výmluvnou chybou.',
    firewallBridgesEmpty: 'Žádný nespravovaný bridge nesouhlasí s firewallovými chainy, které TVirt vykresluje na tomto uzlu.',
    firewallBridgeAdd: 'Přidat bridge',
    firewallBridgeInvalid: 'Není to název linuxového rozhraní (1-15 znaků, bez lomítka a mezery)',
    firewallBridgeDuplicate: 'Název už je v seznamu',
    colMarkDevice: 'Podle zařízení',
    colMarkPort: 'Podle portu',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'osiřelé — registrované, ale už nedetekované: znovu ho připojte, nebo zrušte označení',
    noGpus: 'Zatím nebyla pozorována žádná GPU',
    noUsb: 'Zatím nebylo pozorováno žádné USB zařízení',
    networkGeneration: 'Generace sítě',
    applied: 'Aplikována',
    converged: 'sladěno',
    behind: 'pozadu — {m} / {n}',
    notConfigured: 'nenakonfigurováno',
    rollbackBody: 'Aplikace generace {gen} selhala: {error}',
    rolledBackChip: 'rollback proveden',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Evidence spravovaných NIC — registrace JE deklarací správy: registrovaná NIC bez konfigurace se nechává netknutá (clear-if ji deklaruje výslovně čistou), neregistrovaného zařízení se nikdy nic nedotkne',
    addNic: 'Registrovat NIC',
    addNicTitle: 'Registrovat NIC (add-nic)',
    delNic: 'Ukončit správu',
    delNicTitle: 'Ukončit správu (del-nic)',
    delNicConfirm:
      'Správa {name} končí: záznam v evidenci i jeho konfigurace se odstraní a profil TVirt se odebere — samotné zařízení zůstane tak, jak ho má Linux.',
    nicName: 'Název zařízení',
    nicMac: 'Trvalá MAC adresa',
    nicMacHint: 'trvalá hardwarová MAC — stabilní identita nastavená TVirt Server Installerem',
    colObserved: 'Pozorována',
    nicObserved: 'pozorována',
    nicNotObserved: 'nepozorována',
    nicMacMismatch: 'Neshoda MAC — pozorována {mac}',
    noNics: 'Žádná NIC není registrována — zaregistrujte zařízení a začněte ho spravovat',
    noManagedDevices: 'Žádná spravovaná zařízení — nejdřív zaregistrujte NIC, všechno se staví na evidenci',
    inventoryTitle: 'Pozorovaná zařízení',
    inventorySubtitle: 'Obnovováno workerem uzlu při každém průchodu rekonciliace — validace ověřuje názvy zařízení proti tomuto inventáři',
    colDevice: 'Zařízení',
    colType: 'Typ',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Rychlost',
    colTopology: 'Topologie',
    colMtu: 'MTU',
    colAddresses: 'Adresy',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP neagreguje',
    noInventory: 'Zatím nebyla nahlášena žádná zařízení',
    interfacesTitle: 'Rozhraní',
    interfacesSubtitle:
      'Konfigurace L3 registrovaných NIC a deklarovaných logických zařízení — set-if nahradí celý blok, edit-if upraví vlastnosti, clear-if ho vyprázdní (explicitní čistota)',
    colConfig: 'Požadovaná konfigurace',
    clean: 'čisté',
    setIf: 'Upravit adresaci',
    setIfTitle: 'Upravit adresaci (set-if)',
    editIf: 'Upravit vlastnosti',
    editIfTitle: 'Upravit vlastnosti (edit-if)',
    clearIf: 'Vyprázdnit konfiguraci',
    clearIfTitle: 'Vyprázdnit konfiguraci (clear-if)',
    clearIfConfirm: 'Konfigurace rozhraní se vyprázdní. Čisté rozhraní je předpokladem pro jeho zapojení jako člena bondu/bridge nebo parenta VLAN.',
    ip4Mode: 'Režim IPv4',
    ip6Mode: 'Režim IPv6',
    modeUnconfigured: 'Nenakonfigurovaný',
    modeStatic: 'Statický',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adresy IPv4',
    ip6Addresses: 'Adresy IPv6',
    addressesHint: 'CIDR, oddělené čárkou',
    gw4: 'Brána IPv4',
    gw6: 'Brána IPv6',
    dns: 'Servery DNS',
    dnsHint: 'oddělené čárkou — prázdné vymaže DNS (set-if nahrazuje blok)',
    routes4: 'Statické trasy IPv4',
    routes6: 'Statické trasy IPv6',
    routeTo: 'Cíl (CIDR)',
    routeVia: 'Přes',
    addRoute: 'Přidat trasu',
    routesChip: 'trasy',
    mtu: 'MTU',
    mtuHint: 'prázdné = default ovladače',
    vlansTitle: 'VLAN',
    addVlan: 'Přidat VLAN',
    addVlanTitle: 'Přidat VLAN (add-vlan)',
    delVlanTitle: 'Odstranit VLAN (del-vlan)',
    vlanParent: 'Parent rozhraní',
    vlanId: 'VLAN ID',
    vlanPreview: 'Název zařízení',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Žádná VLAN není deklarována',
    bondsTitle: 'Bondy',
    addBond: 'Přidat bond',
    addBondTitle: 'Přidat bond (add-bond)',
    editBondTitle: 'Upravit bond',
    editBond: 'Uložit bond',
    delBondTitle: 'Odstranit bond (del-bond)',
    bondName: 'Název bondu',
    members: 'Členové',
    membersHint: 'členy musí být čistá rozhraní (bez konfigurace L3)',
    bondMode: 'Režim',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primární člen',
    rate: 'LACP rate',
    hash: 'Politika hashe při vysílání',
    colMembers: 'Členové',
    colMode: 'Režim',
    noBonds: 'Žádný bond není deklarován',
    bridgesTitle: 'Bridge',
    addBridge: 'Přidat bridge',
    addBridgeTitle: 'Přidat bridge (add-bridge)',
    editBridgeTitle: 'Upravit bridge',
    editBridge: 'Uložit bridge',
    delBridgeTitle: 'Odstranit bridge (del-bridge)',
    bridgeName: 'Název bridge',
    stp: 'STP',
    stpOn: 'STP zapnuto',
    stpOff: 'STP vypnuto',
    colStp: 'STP',
    noBridges: 'Žádný bridge není deklarován',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Nastavit hostname',
    setHostnameTitle: 'Nastavit hostname (set-hostname)',
    hostnameHint: 'Jen identita OS — názvu uzlu v klastru se to nedotkne',
    notSet: 'nenastaveno',
    staticHostsTitle: 'Statické záznamy hostitelů',
    addStaticHost: 'Přidat záznam',
    addStaticHostTitle: 'Přidat statický záznam hostitele',
    delStaticHostTitle: 'Odstranit statický záznam hostitele',
    hostIp: 'IP adresa',
    hostNames: 'Názvy',
    hostNamesHint: 'oddělené čárkou nebo mezerou',
    colIp: 'IP',
    colNames: 'Názvy',
    noStaticHosts: 'Žádné statické záznamy hostitelů',
    delConfirm: 'Odebrání {name} z požadovaného dokumentu — worker uzlu konverguje s checkpointem NetworkManageru a automatickým rollbackem.',
    remove: 'Odebrat',
    opError: 'Síťová operace byla odmítnuta'
  }
}
